/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import Box from '@material-ui/core/Box';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
// import custom Component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ClearAuditsForNDCPopup from './ClearAuditsForNDCPopup';
// Import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  redirectURLLink,
  closeTab,
  handleQuarterFormate,
  handleScrollToEvent,
  getCommonDropdownList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  TableHeaderForNDCLevelDetail,
  TableHeaderForNDCAuditDescription,
} from './gridComponents/tableHead';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import {
  dispatchAllNDCs,
  getNdcGrid,
  getUnitConversionDetail,
  handleErrorMessagesClear,
} from '../../../Maintain/unitConversion/store/actions';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import {
  callSearchClaimAPI,
  getClaimTableInfo,
  setSelectedClaim,
  setSelectedClaimMode,
} from '../../../Display/Claim/store/action';
import {
  handleErrorMessages,
  getSearchInvoiceByCriteriaList,
  setInvoiceAuditDetailTab,
  postSaveOrUpdate,
  getFindNDCLevelDetailList,
  getNDCAuditDescription,
  dispatchPagValue,
  getExistingCorrLinkIds,
  getRebateProgramDropdownList,
  setChangesDataList,
  selectedAuditType as resetSelectedAuditType,
} from '../store/Actions';
import { viewPortHeight_350_cbi } from '../../../../SharedModules/CommonConstants/commonConstants';
import { getAccRecNDCSingleData } from '../../AccountReceivable/MfgAccountsRec/store/actions';
import { ndcDetailFirstLoadAction } from '../../AccountReceivable/AccRecNDCDetail/store/actions';
import {
  getManuARForSglRpcNavFn,
  goToArSummaryAccRecNDCSingle,
} from '../../AccountReceivable/ARCommonFunctions';

const InvoiceAuditViewDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Dispatch function
  const addEditReduxInvoiceAuditDetail = (value) =>
    dispatch(setInvoiceAuditDetailTab(value));
  // use Selector function
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const invoiceAuditDTabData = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.invoiceAuditDetailObj
  );
  const fetchState = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.searchScreenObj?.state
  );

  const drugAuditResponses = useSelector(
    (state) =>
      state.sharedState.InvoiceAuditsReducer.searchInvoiceByCriteriaList
        ?.drugAuditResponses
  );
  const NDCLevelDetailList = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.ndcLevelDetailList
  );
  const NDCAuditDescriptionList = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.ndcAuditDescriptionList
  );
  const changesDataList = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.changesDataList
  );
  const selectedAuditType = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.selectedAuditType
  );

  const invoiceAuditGridResponse = useSelector(
    (state) =>
      state.sharedState.InvoiceAuditsReducer.searchInvoiceByCriteriaList
        ?.invoiceAuditGridResponse2
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.errorMessagesInRedux
  );
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.InvoiceAuditsReducer.saveOrUpdateMessage;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues?.data
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const pagValueForDisplay = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.pagValueForDisplay
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  // variable deceleration
  const gridRef = React.useRef();
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [successMessages, setSuccessMessage] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [fullScreenView1, setFullScreenView1] = useState(false);
  const [fullScreenView2, setFullScreenView2] = useState(false);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [clearAuditPopup, setClearAuditPopup] = useState(false);
  const [clearAuditData, setClearAuditData] = useState({});
  const [showComments, setShowComments] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [linkTableName, setLinkTableName] = useState('DRUG_QTR_DETAILS');
  const [tableName, setTableName] = useState('DRUG_QTR_DETAILS');
  const [selectRowData, setSelectRowData] = useState({});
  const [keyValue, setKeyValue] = useState([]);
  const [gridParams, setGridParams] = useState(null);
  const [gridAuditParams, setGridAuditParams] = useState(null);
  const [gridAuditDesParams, setGridAuditDesParams] = useState(null);
  const [nextPaginationVal, setNextPaginationVal] = useState(null);
  const [previousPaginationVal, setPreviousPaginationVal] = useState(null);
  const [stateCC, setStateCC] = useState(true);
  const [stateCCAuditTable, setStateCCAuditTable] = useState(true);
  const [selectedData, setSelectedData] = React.useState([]);
  const [textBoxPaginate, setTextBoxPaginate] = useState(pagValueForDisplay);
  const [pagValueToImplement, setPagValueToImplement] = useState(
    invoiceAuditDTabData?.pagValueToImplement
      ? invoiceAuditDTabData?.pagValueToImplement
      : 1
  );
  const [invoiceAuditDetail, setInvoiceAuditDetail] = useState({
    invoiceNum: null,
    mfgId: null,
    quarter: '',
    rebateProgramCd: null,
    mfgName: null,
    auditTypeCd: null,
    clearedIndex: fetchState?.clearedIndex,
  });
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    if (invoiceAuditDetail && Object.keys(invoiceAuditDetail).length > 0) {
      addEditReduxInvoiceAuditDetail({
        invoiceAuditDetail,
        pagValueToImplement,
        selectRowData,
        showComments,
        tableName,
        fullScreenView,
        fullScreenView1,
        fullScreenView2,
        disabledSaveCancelBtn,
      });
    }
  }, [selectRowData]);
  //invoiceAuditDetail,pagValueToImplement, selectRowData, showComments, tableName, fullScreenView, fullScreenView1, fullScreenView2, disabledSaveCancelBtn
  React.useEffect(() => {
    if (!changesDataList?.length > 0) {
      setDisabledSaveCancelBtn(true);
    }
  }, [changesDataList]);
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.detailScreenErrors &&
      errorMessagesFromRedux?.detailScreenErrors.length > 0
    ) {
      tabHighLigther('/invoiceAuditsDetail', true);
    } else {
      tabHighLigther('/invoiceAuditsDetail', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handing refresh functionality
  // set common dropdown list
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(fetchState?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [fetchState?.planTypeCd]);
  // handle all plan type get service
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['AUDIT_TYPE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (invoiceAuditDTabData && Object.keys(invoiceAuditDTabData).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/invoiceAuditsDetail' && !disabledSaveCancelBtn) {
            item.isFormDirty = true;
          } else if (item.navTo === '/invoiceAuditsDetail')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disabledSaveCancelBtn || invoiceAuditDTabData]);
  // handing NDC level Invoice Grid Service calling
  const fetchFindNDCLevelInvoiceDetail = async (
    singleInvoiceDetail,
    params
  ) => {
    const Obj = {
      auditType:
        fetchState?.auditTypeCd === 'Selected'
          ? fetchState.selectedAuditType
          : fetchState.auditTypeCd,
      rebateProgramCode: singleInvoiceDetail.rebateProgramCd,
      quarter: singleInvoiceDetail.quarter,
      clearedIndex: fetchState?.clearedIndex ? 1 : 0,
      unclearedIndex: fetchState?.clearedIndex ? 0 : 1,
      asCode: fetchState.selectBy,
    };
    const drugSeqArr = [];
    if (fetchState?.selectBy === 'NDC') {
      fetchState.searchTypeState.ndcRightTableDataRedux.forEach((elem) => {
        drugSeqArr.push(elem.drugSeqNum);
      });
    }

    const result = await dispatch(
      fetchState.selectBy === 'NDC'
        ? getFindNDCLevelDetailList({
            ...Obj,
            drugSeqNum: drugSeqArr,
            mfgId: singleInvoiceDetail.mfgId,
          })
        : getFindNDCLevelDetailList({
            ...Obj,
            mfgId: singleInvoiceDetail.mfgId,
          })
    );
    if (result?.ndcLevelDetailList?.length > 0) {
      const selectRow = result?.ndcLevelDetailList?.sort((a, b) => {
        return parseFloat(a.ndc) - parseFloat(b.ndc);
      })[0];
      if (gridParams?.api) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'ndc', sort: 'asc' }],
        });
        gridParams.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
      }
      setSelectRowData(selectRow);
      handleExistingCommentList(result?.ndcLevelDetailList, 'NDCDetailsList');
      fetchNDCAuditDescription(selectRow, singleInvoiceDetail, params);
    }
  };
  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data, name) => {
    if (data && data.length > 0) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: data.map((item) => {
          return item.corrLinkId;
        }),
      });
      const tempObj = data?.map((item) => {
        if (
          result?.data?.filter((x) => {
            return x === item?.corrLinkId;
          }).length > 0
        ) {
          item.ccCommentsExist = 1;
        } else {
          item.ccCommentsExist = 0;
        }
        return item;
      });

      if (name === 'NDCDetailsList') {
        dispatch(getFindNDCLevelDetailList(tempObj, 'update'));
        // eslint-disable-next-line no-unused-expressions
        gridParams?.api.refreshCells();
      } else if (name === 'NDCAuditDesList') {
        dispatch(getNDCAuditDescription(tempObj, 'update'));
        setStateCCAuditTable(true);
        // eslint-disable-next-line no-unused-expressions
        gridAuditDesParams?.api.refreshCells();
      } else if (name === 'drugAuditResponses') {
        const Obj = {
          invoiceAuditGridResponse2: invoiceAuditGridResponse,
          drugAuditResponses: tempObj,
        };
        dispatch(getSearchInvoiceByCriteriaList(Obj, 'update'));
        setStateCC(true);
        // eslint-disable-next-line no-unused-expressions
        gridAuditParams?.api.refreshCells();
      }
    }
  };

  // set Initial state values
  React.useEffect(() => {
    handleScrollToEvent();
    if (
      invoiceAuditDTabData &&
      Object.keys(invoiceAuditDTabData)?.length === 0
    ) {
      if (invoiceAuditGridResponse?.length > 0) {
        setStateCC(false);
        setStateCCAuditTable(false);
        const newObj = invoiceAuditGridResponse?.map((item) => {
          const quarter = handleQuarterFormate(item.quarter);
          item.quarter = quarter;
          return item;
        });
        const Obj = {
          invoiceAuditGridResponse2: newObj,
          drugAuditResponses: drugAuditResponses,
        };
        dispatch(getSearchInvoiceByCriteriaList(Obj, 'update'));
        handleExistingCommentList(drugAuditResponses, 'drugAuditResponses');
        const singleInvoiceDetail = newObj[pagValueToImplement - 1];
        setInvoiceAuditDetail(singleInvoiceDetail);
        setDisabledSaveCancelBtn(true);
        setErrorMessages([]);
        addEditReduxInvoiceAuditDetail({
          invoiceAuditDetail: singleInvoiceDetail,
          disabledSaveCancelBtn: true,
        });
        fetchFindNDCLevelInvoiceDetail(singleInvoiceDetail);
      }
    } else {
      const tempObj = invoiceAuditDTabData;
      if (tempObj && tempObj.invoiceAuditDetail)
        setInvoiceAuditDetail(tempObj.invoiceAuditDetail);
      if (tempObj && tempObj.disabledSaveCancelBtn)
        setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj && tempObj.fullScreenView)
        setFullScreenView(tempObj.fullScreenView);
      if (tempObj && tempObj.fullScreenView1)
        setFullScreenView1(tempObj.fullScreenView1);
      if (tempObj && tempObj.fullScreenView2)
        setFullScreenView2(tempObj.fullScreenView2);
      if (tempObj && tempObj.pagValueToImplement)
        setPagValueToImplement(tempObj.pagValueToImplement);
      if (tempObj && tempObj.selectRowData)
        setSelectRowData(tempObj.selectRowData);
      if (tempObj && tempObj.showComments)
        setShowComments(tempObj.showComments);
      if (tempObj && tempObj.tableName) setTableName(tempObj.tableName);
    }
  }, [invoiceAuditGridResponse]);
  // set Pagination value on state
  React.useEffect(() => {
    if (
      invoiceAuditDTabData &&
      Object.keys(invoiceAuditDTabData).length > 0 &&
      (disabledSaveCancelBtn || invoiceAuditDTabData.disabledSaveCancelBtn)
    ) {
      if (invoiceAuditGridResponse && invoiceAuditGridResponse.length > 0) {
        setInvoiceAuditDetail({});
        const singleInvoiceDetail =
          invoiceAuditGridResponse[pagValueToImplement - 1];
        setInvoiceAuditDetail(singleInvoiceDetail);
        const objData = invoiceAuditDTabData || {};
        addEditReduxInvoiceAuditDetail({
          ...objData,
          invoiceAuditDetail: singleInvoiceDetail,
          pagValueToImplement: pagValueToImplement,
        });
        if (pagValueToImplement !== 0) {
          fetchFindNDCLevelInvoiceDetail(singleInvoiceDetail);
        }
        // eslint-disable-next-line no-unused-expressions
        gridAuditParams?.api.refreshCells();
      }
    }
  }, [pagValueToImplement]);
  // set pagination value on Redux
  React.useEffect(() => {
    if (disabledSaveCancelBtn) {
      dispatch(dispatchPagValue(textBoxPaginate));
    }
  }, [textBoxPaginate]);
  // handing by default 1st row selection function
  const onFirstDataRendered = (api) => {
    if (!api) return;
    api.forEachNode((node) => node.rowIndex === 0 && node.setSelected(true));
  };
  const onGridReady = (params) => {
    setGridParams(params);
  };
  // handing by default 1st row selection function
  const onGridReadyForDrugAuditDes = (params) => {
    setGridAuditDesParams(params);
  };
  // handing by default 1st row selection function
  const onGridReadyForDrugAudit = (params) => {
    setGridAuditParams(params);
  };

  React.useEffect(() => {
    if (!_.isEmpty(selectedData)) {
      let newData = _.cloneDeep(changesDataList);
      const alList = [];
      _.forEach(selectedData, (data) => {
        const checkList = !_.isEmpty(changesDataList)
          ? _.filter(
              changesDataList,
              (l) =>
                l.corrLinkId === data.corrLinkId &&
                l.auditTypeCd === data.auditTypeCd &&
                (l.auditClearedInd === data.auditClearedInd ||
                  l.auditClearedInd !== data.auditClearedInd)
            )
          : [];
        if (_.isEmpty(checkList)) {
          newData.push(data);
        } else if (checkList.auditClearedInd !== data.auditClearedInd) {
          alList.push(data);
        }
      });

      if (!_.isEmpty(alList)) {
        newData = _.filter(newData, (l) => {
          const al = _.filter(
            alList,
            (x) =>
              l.corrLinkId === x.corrLinkId && l.auditTypeCd === x.auditTypeCd
          );
          if (!_.isEmpty(al)) {
            const flData = al[0];
            if (l.auditClearedInd !== flData.auditClearedInd) {
              l.auditClearedInd = flData.auditClearedInd;
              return l;
            }
          } else {
            return l;
          }
        });
      }
      dispatch(setChangesDataList(newData));
      setSelectedData([]);
    }
  }, [selectedData]);
  // handing NDC audit description Grid list API calling
  const fetchNDCAuditDescription = async (
    data,
    singleInvoiceDetail,
    params
  ) => {
    if (
      NDCAuditDescriptionList?.length === 0 ||
      NDCAuditDescriptionList?.filter((x) => {
        return x.drugSeqNum !== data.drugSeqNum;
      }).length > 0 ||
      !disabledSaveCancelBtn
    ) {
      if (singleInvoiceDetail && Object.keys(singleInvoiceDetail)?.length > 0) {
        setStateCCAuditTable(false);
        const result = await dispatch(
          getNDCAuditDescription({
            drugSeqNum: data?.drugSeqNum,
            auditType:
              fetchState?.auditTypeCd === 'Selected'
                ? fetchState.selectedAuditType
                : fetchState.auditTypeCd,
            rebateProgramCode: singleInvoiceDetail.rebateProgramCd,
            quarter: singleInvoiceDetail.quarter,
            clearedIndex: fetchState?.clearedIndex ? 1 : 0,
            asCode: fetchState.selectBy,
          })
        );
        const list = result?.ndcAuditDescriptionList?.map((item) => {
          let checkClearedList = !_.isEmpty(changesDataList)
            ? _.filter(
                changesDataList,
                (l) =>
                  l.corrLinkId === item?.corrLinkId &&
                  l.drugSeqNum === item?.drugSeqNum &&
                  l.auditTypeCd === item?.auditTypeCd
              )
            : [];
          if (params === 'clear') {
            checkClearedList = [];
          }
          return {
            ...item,
            auditClearedInd:
              checkClearedList?.length > 0
                ? checkClearedList[0]?.auditClearedInd
                : item?.auditClearedInd,
          };
        });
        if (list?.length > 0) {
          handleExistingCommentList(list, 'NDCAuditDesList');
        } else {
          setStateCCAuditTable(true);
        }
      }
    }
  };

  // calling view Detail page initial API
  const fetchViewDetailFunction = async () => {
    setStateCC(false);
    const Obj = {
      auditType:
        fetchState && fetchState.auditTypeCd === 'Selected'
          ? fetchState.selectedAuditType
          : fetchState.auditTypeCd,
      rebateProgramCode: fetchState.rebateProgramCd,
      quarter: fetchState.quarterValue,
      clearedIndex: fetchState?.clearedIndex ? 1 : 0,
      unclearedIndex: fetchState?.clearedIndex ? 0 : 1,
      asCode: fetchState.selectBy,
    };
    const drugSeqArr = [];
    if (fetchState.selectBy === 'NDC') {
      fetchState.searchTypeState.ndcRightTableDataRedux.forEach((elem) => {
        drugSeqArr.push(elem.drugSeqNum);
      });
    }
    getSearchInvoiceByCriteriaList([], 'update');
    const resultData = await dispatch(
      fetchState.selectBy === 'M'
        ? getSearchInvoiceByCriteriaList({
            ...Obj,
            mfgId: invoiceAuditDetail.mfgId,
          })
        : fetchState.selectBy === 'NDC'
        ? getSearchInvoiceByCriteriaList({ ...Obj, drugSeqNum: drugSeqArr })
        : getSearchInvoiceByCriteriaList(Obj)
    );
    if (
      resultData?.searchInvoiceByCriteriaList?.invoiceAuditGridResponse2
        ?.length > 0
    ) {
      const newObj =
        resultData.searchInvoiceByCriteriaList.invoiceAuditGridResponse2.map(
          (item) => {
            item.quarter = handleQuarterFormate(item.quarter);
            return item;
          }
        );
      const Obj2 = {
        invoiceAuditGridResponse2: newObj,
        drugAuditResponses:
          resultData.searchInvoiceByCriteriaList.drugAuditResponses,
      };
      dispatch(getSearchInvoiceByCriteriaList(Obj2, 'update'));
      handleExistingCommentList(
        resultData.searchInvoiceByCriteriaList?.drugAuditResponses,
        'drugAuditResponses'
      );
    }
  };
  // handle after call service show success and error message
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage?.message === 'Success') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      setErrorMessages([]);
      setDisabledSaveCancelBtn(true);
      const objData = invoiceAuditDTabData || {};
      addEditReduxInvoiceAuditDetail({
        ...objData,
        disabledSaveCancelBtn: true,
      });
      if (!clickOncloseTabBtn) {
        dispatch(postSaveOrUpdate(null));
        addEditReduxInvoiceAuditDetail({});
        closeTab('/invoiceAuditsDetail', history, dispatch);
      }
    } else if (saveOrUpdateMessage === 'failed') {
      setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn(true);
    }
  }, [saveOrUpdateMessage]);
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (linkTableName === 'DRUG_QTR_DETAILS' && showComments) {
      const tempObj =
        NDCLevelDetailList &&
        NDCLevelDetailList.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(getFindNDCLevelDetailList(tempObj, 'update'));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    } else if (tableName === 'DRUG_AUDIT_DES' && showComments) {
      const tempObj =
        NDCAuditDescriptionList &&
        NDCAuditDescriptionList.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });

      dispatch(getNDCAuditDescription(tempObj, 'update'));
      // eslint-disable-next-line no-unused-expressions
      gridAuditDesParams?.api.refreshCells();
    } else if (tableName === 'DRUG_AUDIT' && showComments) {
      const tempObj =
        drugAuditResponses &&
        drugAuditResponses.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      const Obj = {
        invoiceAuditGridResponse2: invoiceAuditGridResponse,
        drugAuditResponses: tempObj,
      };
      dispatch(getSearchInvoiceByCriteriaList(Obj, 'update'));
      // eslint-disable-next-line no-unused-expressions
      gridAuditParams?.api.refreshCells();
    }
  }, [commentsList]);
  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    if (!disabledSaveCancelBtn) {
      dispatch(
        handleErrorMessages({
          detailScreenErrors: [],
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
      setSuccessMessage([]);
      openSave(value);
    }
  };
  // handing save API calling
  const masterDataSave = async () => {
    handelCancelClose();
    setOpen(false);
    const payload = [];
    if (changesDataList?.length > 0) {
      changesDataList.forEach((li) => {
        const obj = {};
        obj.drugAuditId = {
          drugSeqNum: li?.drugSeqNum,
          rebateProgramCd: li?.rebateProgramCd,
          qtr: handleQuarterFormate(li?.qtr),
          auditTypeCd: li?.auditTypeCd,
        };
        obj.invNum = invoiceAuditDetail?.invoiceNum;
        obj.auditClearedInd = parseInt(li?.auditClearedInd, [0, 1]);
        obj.lastUpdateUserId = UserDefaultValues?.userId
          ? UserDefaultValues?.userId
          : logInUser;
        payload.push(obj);
      });
    }
    if (drugAuditResponses?.filter((x) => x?.addEditRow)?.length > 0) {
      const newObj = drugAuditResponses?.filter((x) => x?.addEditRow);
      newObj.forEach((item) => {
        payload.push({
          drugAuditId: {
            drugSeqNum: item.drugSeqNum,
            rebateProgramCd: item.rebateProgramCd,
            qtr: handleQuarterFormate(item.qtr),
            auditTypeCd: item.auditTypeCd,
          },
          invNum: invoiceAuditDetail?.invoiceNum,
          auditClearedInd: parseInt(item.auditClearedInd, [0, 1]),
          lastUpdateUserId: UserDefaultValues?.userId
            ? UserDefaultValues?.userId
            : logInUser,
        });
      });
    }
    if (payload?.length > 0) {
      dispatch(setChangesDataList([]));
      const result = await dispatch(postSaveOrUpdate(payload));
      if (result?.saveOrUpdateMessage?.message === 'Success') {
        setDisabledSaveCancelBtn(true);
        handleScrollToEvent();

        // eslint-disable-next-line no-unused-expressions
        gridAuditParams?.api.refreshCells();
        // eslint-disable-next-line no-unused-expressions
        gridAuditDesParams?.api.refreshCells();
        if (nextPaginationVal !== null) {
          addEditReduxInvoiceAuditDetail({
            disabledSaveCancelBtn: true,
          });
          setTextBoxPaginate(nextPaginationVal);
          dispatch(dispatchPagValue(nextPaginationVal));
          const singleInvoiceDetail =
            invoiceAuditGridResponse[nextPaginationVal - 1];
          setInvoiceAuditDetail(singleInvoiceDetail);
          fetchFindNDCLevelInvoiceDetail(singleInvoiceDetail);
          if (drugAuditResponses?.filter((x) => x?.addEditRow)?.length > 0) {
            const Obj = {
              invoiceAuditGridResponse2: invoiceAuditGridResponse,
              drugAuditResponses: [],
            };
            dispatch(getSearchInvoiceByCriteriaList(Obj, 'update'));
            fetchViewDetailFunction();
          }
        }
        resetAllFields(!!nextPaginationVal, 'update');
        dispatch(setChangesDataList([]));
      }
    }
  };
  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage?.message === 'Success') {
      dispatch(postSaveOrUpdate(null));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/invoiceAuditsDetail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/invoiceAuditsDetail' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // handing  full screen view function
  const handleFullScreenView = () => {
    setErrorMessages([]);
    setFullScreenView(!fullScreenView);
    const obj = invoiceAuditDTabData || {};
    addEditReduxInvoiceAuditDetail({ ...obj, fullScreenView: !fullScreenView });
  };
  // handing full screen view function
  const handleFullScreenView1 = () => {
    setErrorMessages([]);
    setFullScreenView1(!fullScreenView1);
    const obj = invoiceAuditDTabData || {};
    addEditReduxInvoiceAuditDetail({
      ...obj,
      fullScreenView1: !fullScreenView1,
    });
  };
  // handing full screen view function
  const handleFullScreenView2 = () => {
    setErrorMessages([]);
    setFullScreenView2(!fullScreenView2);
    const obj = invoiceAuditDTabData || {};
    addEditReduxInvoiceAuditDetail({
      ...obj,
      fullScreenView2: !fullScreenView2,
    });
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    setErrorMessages([]);
    if (NDCAuditDescriptionList?.length > 0 && gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  // handing view History popup
  const handleViewHistory = () => {
    setErrorMessages([]);
    setShowViewHistory(true);
    const temp = {
      DRUG_SEQ_NUM: selectRowData?.drugSeqNum,
      QTR: fetchState.quarterValue,
      REBATE_PROGRAM_CD: fetchState.rebateProgramCd,
    };
    setKeyValue(
      linkTableName === 'DRUG_AUDIT'
        ? { ...temp, AUDIT_TYPE_CD: selectRowData?.auditTypeCd }
        : temp
    );
  };

  // handing reset All fields & data
  const resetAllFields = (value, action) => {
    setErrorMessages([]);
    handelCancelClose();
    if (action !== 'update') {
      setSuccessMessage([]);
    }
    setDisabledSaveCancelBtn(true);
    const singleInvoiceDetail =
      invoiceAuditGridResponse[pagValueToImplement - 1];
    setInvoiceAuditDetail(singleInvoiceDetail);
    fetchFindNDCLevelInvoiceDetail(singleInvoiceDetail, 'clear');
    dispatch(getFindNDCLevelDetailList([], 'update'));
    dispatch(getNDCAuditDescription([], 'update'));
    dispatch(resetSelectedAuditType(''));
    if (action === 'update') {
      const invoiceDrugAudits = drugAuditResponses?.filter(
        (x) => x?.invoiceNum === singleInvoiceDetail?.invoiceNum
      );
      if (invoiceDrugAudits?.length > 0) {
        setStateCC(true);
        const refreshedDrugAudits = drugAuditResponses.map((item) => ({
          ...item,
          addEditRow: false,
        }));
        dispatch(
          getSearchInvoiceByCriteriaList(
            {
              invoiceAuditGridResponse2: invoiceAuditGridResponse,
              drugAuditResponses: refreshedDrugAudits,
            },
            'update'
          )
        );
        handleExistingCommentList(refreshedDrugAudits, 'drugAuditResponses');
      } else {
        setStateCC(false);
      }
    } else {
      setStateCC(false);
    }
    dispatch(
      handleErrorMessages({
        detailScreenErrors: [],
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
      })
    );
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/invoiceAuditsDetail') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setErrorMessages([]);
    setOpen(false);
    if (previousPaginationVal !== null) {
      setTextBoxPaginate(previousPaginationVal);
      setNextPaginationVal(null);
    }
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  // Checkbox data handling
  React.useEffect(() => {
    if (selectedAuditType) {
      setDisabledSaveCancelBtn(true);
      dispatch(getNDCAuditDescription([], 'update'));
      handleAllAuditDescriptionAPIcall();

      setClearAuditPopup(false);
    }
  }, [selectedAuditType]);

  const handleAllAuditDescriptionAPIcall = async () => {
    const singleInvoiceDetail =
      invoiceAuditGridResponse[pagValueToImplement - 1];
    const tempObj = NDCLevelDetailList?.filter((x) => {
      return x.ndc === selectedAuditType?.ndc;
    });
    if (tempObj?.length > 0) {
      const itemList = [...changesDataList];
      for (let i = 0; i < tempObj?.length; i += 1) {
        if (
          singleInvoiceDetail &&
          Object.keys(singleInvoiceDetail)?.length > 0
        ) {
          setStateCCAuditTable(false);
          const result = await dispatch(
            getNDCAuditDescription({
              drugSeqNum: tempObj[i]?.drugSeqNum,
              auditType:
                fetchState?.auditTypeCd === 'Selected'
                  ? fetchState.selectedAuditType
                  : fetchState.auditTypeCd,
              rebateProgramCode: singleInvoiceDetail.rebateProgramCd,
              quarter: singleInvoiceDetail.quarter,
              clearedIndex: fetchState?.clearedIndex ? 1 : 0,
              asCode: fetchState.selectBy,
            })
          );
          if (result?.ndcAuditDescriptionList?.length > 0) {
            result.ndcAuditDescriptionList.forEach((item) => {
              itemList.push({
                ...item,
                auditClearedInd:
                  selectedAuditType?.auditTypeCd === 'All' ||
                  item.auditTypeCd?.trim() ===
                    selectedAuditType?.auditTypeCd?.trim()
                    ? 1
                    : 0,
              });
            });
          }
          if (itemList?.length === 0) {
            setDisabledSaveCancelBtn(true);
          } else {
            setStateCCAuditTable(true);
            setDisabledSaveCancelBtn(false);
          }

          dispatch(setChangesDataList(itemList));
          const updatedList = NDCAuditDescriptionList?.map((data) => {
            const obj = { ...data };
            const newObj1 = _.cloneDeep(obj);
            newObj1.drugSeqNum = data.drugSeqNum;
            if (selectedAuditType?.auditTypeCd === 'All') {
              obj.auditClearedInd = 1;
              return obj;
            }
            if (data.auditTypeCd === selectedAuditType?.auditTypeCd) {
              obj.auditClearedInd = 1;
              return obj;
            }
            return obj;
          });
          dispatch(getNDCAuditDescription(updatedList, 'update'));
        }
      }
    }
  };
  // handing NDC detail page redirect
  const handleViewDetailsForNDC = async (data) => {
    const response = await getNDCDetails([
      { ndc: data.ndc, drugName: data?.drugName },
    ]);
    dispatch(setNDCErrorPopupMessage(null));
    dispatch(setCurrentNDCDetailsIndex(1));
    dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
    dispatch(setNDCDetails([{ ndc: data.ndc, drugName: data.drugName }]));
    redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
  };
  // handing Unit conversion page redirect
  const handleViewDetailsForUnitConversion = async (data) => {
    setErrorMessages([]);
    dispatch(
      getUnitConversionDetail({
        drugSeqNum: [data?.drugSeqNum],
      })
    );
    const result = await dispatch(
      getNdcGrid({
        drugSeqNum: data?.drugSeqNum,
      })
    );
    if (result.payLoad && result.payLoad?.length > 0) {
      redirectURLLink(
        '/unitConversion-detail',
        'Display Unit Conversion for NDC',
        history,
        dispatch
      );
    } else {
      handleScrollToEvent();
      setSuccessMessage([]);
      setErrorMessages([constantMessageData.MNFC_NDC_ERROR_MSG]);
      // setTimeout(() => setErrorMessages([]), 5000);
    }
  };
  // Go to Account Receivable NDC details
  const handleGoToAccRecNDCDetail = async () => {
    setErrorMessages([]);
    const reqPayload = {
      planType: fetchState?.planTypeCd,
      startQtr: invoiceAuditDetail?.quarter,
      endQtr: invoiceAuditDetail?.quarter,
      useOfficialURA: 1,
      mfgId: invoiceAuditDetail && invoiceAuditDetail.mfgId,
      rebateProgram: invoiceAuditDetail?.rebateProgramCd,
    };
    const invoiceDetails = await dispatch(getManuARForSglRpcNavFn(reqPayload));
    const obj = {
      mfgId: invoiceAuditDetail && invoiceAuditDetail.mfgId,
      mfgName: invoiceAuditDetail?.mfgName,
      invoiceNum: invoiceAuditDetail?.invoiceNum,
      invoiceDate: invoiceAuditDetail?.invoiceCreateDt,
      invoiceStatus: invoiceAuditDetail?.invoiceStatusCd,
      uraInfo: 'Official',
      useOfficialURA: 1,
      qtr: invoiceAuditDetail?.quarter,
      pgmInfo: invoiceAuditDetail?.rebateProgramCd,
      pgmCd: invoiceAuditDetail?.rebateProgramCd,
    };
    const payload = {
      mfgId: invoiceAuditDetail?.mfgId,
      startQuarter: invoiceAuditDetail?.quarter,
      aiUseOfficialURA: 1,
      invoiceNumber: invoiceAuditDetail?.invoiceNum,
      rebateProgramCd: invoiceAuditDetail?.rebateProgramCd,
    };
    const accountRecResponse = await dispatch(
      getAccRecNDCSingleData(payload, obj)
    );
    if (!_.isEmpty(accountRecResponse)) {
      dispatch(ndcDetailFirstLoadAction(false));
      goToArSummaryAccRecNDCSingle(
        history,
        invoiceAuditDetail?.rebateProgramCd,
        dispatch
      );
    }
  };

  // handing Invoice Detail page redirect
  const handleViewDetailsForInvoiceDetail = async () => {
    setErrorMessages([]);
    await dispatch(
      getInvoiceDetailsByInvoiceNum({
        invoiceNum: invoiceAuditDetail.invoiceNum,
      })
    );
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };
  // handing Claims page redirect
  const handleViewDetailsForClaims = async (data) => {
    setErrorMessages([]);
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: fetchState.rebateProgramCd,
      searchByNdc: true,
      drugSqnNum: [data.drugSeqNum],
      paidQtr: fetchState.quarterValue,
    });
    if (resultData && resultData?.length > 0) {
      dispatch(setSelectedClaimMode('display'));
      dispatch(setSelectedClaim(resultData));
      dispatch(getClaimTableInfo(true));
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    }
    if (resultData === null) {
      setErrorMessages([constantMessageData.NO_CLAIM_FOUND_INVOICE_AUDIT]);
    }
  };
  // handing pagination text box value
  const handleInputFiledPagination = (value, state) => {
    setErrorMessages([]);
    if (!state) {
      const obj = invoiceAuditDTabData || {};
      setPagValueToImplement(value);
      addEditReduxInvoiceAuditDetail({ ...obj, pagValueToImplement: value });
      if (!disabledSaveCancelBtn) {
        onSubmit(true);
        setNextPaginationVal(value);
        setPreviousPaginationVal(null);
      } else {
        setTextBoxPaginate(value);
        setNextPaginationVal(null);
      }
    } else {
      setTextBoxPaginate(value);
      setNextPaginationVal(null);
      setPreviousPaginationVal(pagValueForDisplay);
    }
  };
  // regex to check its positive whole numbers or not
  function isNumeric(value) {
    return /^\d+$/.test(value);
  }
  // handing Pagination validation on Blur event
  const handlePaginateBlur = () => {
    let arr = errorMessagesFromRedux?.detailScreenErrors
      ? errorMessagesFromRedux.detailScreenErrors
      : [];
    // eslint-disable-next-line no-unused-vars
    let isPass = false;
    let isInputValue = false;
    const inputValue = isNumeric(textBoxPaginate);
    if ((inputValue && textBoxPaginate) > invoiceAuditGridResponse.length) {
      arr = arr.filter((item) => item.errorType !== 'validate');
      arr.push({
        field: 'input',
        errorType: 'inputIsGreter',
        message: constantMessageData.INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
    } else {
      isInputValue = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'inputIsGreter' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }
    if (inputValue && isInputValue && textBoxPaginate !== '0') {
      isPass = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'validate' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
      const obj = invoiceAuditDTabData || {};
      setPagValueToImplement(textBoxPaginate);
      if (!disabledSaveCancelBtn) {
        onSubmit(true);
        setNextPaginationVal(textBoxPaginate);
      } else {
        setNextPaginationVal(null);
      }
      addEditReduxInvoiceAuditDetail({
        ...obj,
        pagValueToImplement: textBoxPaginate,
      });
    } else {
      isPass = false;
      arr = arr.filter((item) => item.errorType !== 'validate');
      if (inputValue && textBoxPaginate < invoiceAuditGridResponse.length) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
      if (inputValue === false) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        detailScreenErrors: [...new Set(arr)],
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
      })
    );
  };
  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="invoice-audit-detail"
    >
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          masterDataSave();
          dispatch(setChangesDataList([]));
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid="cancelPopup"
        title="Cancel"
        onConfim={() => {
          dispatch(setChangesDataList([]));
          resetAllFields('clear');
        }}
        onCancel={() => {
          handelCancelClose();
        }}
      />
      <ClearAuditsForNDCPopup
        data-testid="clearAuditPopup"
        open={clearAuditPopup}
        data={clearAuditData}
        auditTypeOptions={commonDropdownList?.AUDIT_TYPE_CD}
        disabledSaveCancelBtn={disabledSaveCancelBtn}
        handleClose={(value) => {
          setClearAuditPopup(false);
          setClearAuditData({});
          setDisabledSaveCancelBtn(value);
        }}
      />
      <CustomSeparator parent1="Research" parent2="Invoice Audits Detail" />
      {!fullScreenView && !fullScreenView1 && !fullScreenView2 && (
        <>
          <DisplaySuccessMessages successMessages={successMessages} />
          <DisplayErrorMessages
            errorMessages={
              errorMessages && errorMessages.length > 0
                ? [...new Set(errorMessages)]
                : errorMessagesFromRedux?.detailScreenErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux.detailScreenErrors,
                    (l) => l.message
                  )
                : []
            }
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && !fullScreenView1 && !fullScreenView2 && (
        <>
          <Box className="alone-pagination mb-2">
            <Box>
              <Button
                title="Previous"
                className="btns rotate-left"
                data-testid="uc-paginate-arrow-left"
                type="button"
                disabled={
                  !(textBoxPaginate > 1) ||
                  !isNumeric(textBoxPaginate) ||
                  invoiceAuditGridResponse?.length < textBoxPaginate
                }
                onClick={() => {
                  handleInputFiledPagination(
                    parseInt(textBoxPaginate, [0, 1000]) - 1
                  );
                  setErrorMessages([]);
                  setSuccessMessage([]);
                }}
              >
                <SVGComponent iconName="Icon-arrow" />
                <span className="hide-elm">Previous</span>
              </Button>
            </Box>
            <Box>
              <label className="m-0" htmlFor="paginate-count">
                <TextField
                  id="paginate-count"
                  data-testid="uc-input-paginate"
                  variant="outlined"
                  className="searchInput input-count"
                  value={textBoxPaginate || ''}
                  onChange={(e) =>
                    handleInputFiledPagination(e.target.value, true)
                  }
                  onBlur={() => {
                    handlePaginateBlur();
                    setSuccessMessage([]);
                    setErrorMessages([]);
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 9 || e.key === 'Enter') {
                      e.preventDefault();
                      e.target.blur();
                      handlePaginateBlur();
                      setSuccessMessage([]);
                      setErrorMessages([]);
                    }
                  }}
                  size="small"
                />
              </label>
            </Box>
            <Box className="btns">
              {' '}
              {`Of ${
                invoiceAuditGridResponse && invoiceAuditGridResponse.length
              }`}
            </Box>
            <Box>
              <Button
                title="Next"
                className="btns rotate-right ml-0"
                data-testid="uc-paginate-arrow-right"
                type="button"
                disabled={
                  textBoxPaginate > invoiceAuditGridResponse?.length - 1 ||
                  !isNumeric(textBoxPaginate)
                }
                onClick={() => {
                  handleInputFiledPagination(
                    parseInt(textBoxPaginate, [0, 1000]) + 1
                  );
                  setSuccessMessage([]);
                  setErrorMessages([]);
                }}
              >
                <SVGComponent iconName="Icon-arrow" />
                <span className="hide-elm">Next</span>
              </Button>
            </Box>
          </Box>
          <Box className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper form-wrapper-col-6">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="invoiceNumber"
                    label="Invoice Number"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={invoiceAuditDetail && invoiceAuditDetail.invoiceNum}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Quarter"
                    label="Quarter"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={invoiceAuditDetail && invoiceAuditDetail.quarter}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="RebateProgram"
                    label="Rebate Program"
                    fullWidth
                    disabled
                    select
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ id: 'RebateProgram' }}
                    value={
                      invoiceAuditDetail && invoiceAuditDetail.rebateProgramCd
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList?.length > 0
                      ? rebateProgramList?.map((item) => {
                          return (
                            <MenuItem
                              key={item.id}
                              value={item.id}
                              className="frr-logcheck-dropdown-item"
                            >
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-6 frr-invoice-audit-manufacture">
                <div className="mui-custom-form input-md frr-invoiceAudit-width-15per">
                  <TextField
                    id="mfgId"
                    label="Manufacturer ID"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={invoiceAuditDetail && invoiceAuditDetail.mfgId}
                  />
                </div>
                <div className="mui-custom-form input-md frr-invoiceAudit-width-47per">
                  {invoiceAuditDetail?.mfgName?.length > 45 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {invoiceAuditDetail.mfgName}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="mfgName"
                        label="Manufacturer Name"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={`${invoiceAuditDetail.mfgName.substring(
                          0,
                          45
                        )} ...`}
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="mfgName"
                      label="Manufacturer Name"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={invoiceAuditDetail && invoiceAuditDetail.mfgName}
                    />
                  )}
                </div>
                <div className="mui-custom-form input-md">
                  <FormControlLabel
                    className="frr-mt-26 ml-1"
                    control={<Checkbox color="primary" />}
                    label="Include Cleared Audits"
                    value={fetchState?.clearedIndex}
                    checked={fetchState?.clearedIndex}
                    disabled
                  />
                </div>
              </div>
            </div>
          </Box>
          <div className="log-batch-detail-btn-group welcometxt my-4">
            <div className="btn-wrapper">
              <Button
                className="btn btn-success btn-save btn-primary"
                data-testid="view-history"
                type="button"
                onClick={() => {
                  handleViewHistory();
                }}
                disabled={
                  !(selectRowData && Object.keys(selectRowData).length > 0)
                }
              >
                <SVGComponent iconName="Icon-view-history" /> View History
              </Button>
              <Button
                className="btn btn-success btn-save"
                data-testid="saveBtn"
                disabled={disabledSaveCancelBtn || !isEnablebyRole}
                onClick={() => {
                  onSubmit(true);
                }}
              >
                {' '}
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="cancelBtn"
                onClick={() => handleOpenClose()}
                disabled={disabledSaveCancelBtn}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </div>
        </>
      )}
      {!fullScreenView &&
        !fullScreenView1 &&
        drugAuditResponses &&
        drugAuditResponses.filter((x) => {
          return x.invoiceNum === invoiceAuditDetail?.invoiceNum;
        }).length > 0 &&
        stateCC && (
          <div className="">
            <div className="">
              <TableGrid
                data-testid="InvoiceAuditType_IRGL"
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView2}
                handleFullScreenViewClick={handleFullScreenView2}
                gridHeight={fullScreenView2 ? '70vh' : viewPortHeight_350_cbi}
                rowData={drugAuditResponses?.filter((x) => {
                  return x?.invoiceNum === invoiceAuditDetail?.invoiceNum;
                })}
                columnDefs={TableHeaderForNDCAuditDescription}
                exportFile
                animateRows
                sideBar={false}
                fileName="InvoiceAuditType_IRGL"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                gridCall={onGridReadyForDrugAudit}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                onSelect={(e) => {
                  setSelectRowData(e.data);
                  setLinkTableName('DRUG_AUDIT');
                  setTableName('DRUG_AUDIT');
                }}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const [hoverCC, setHoverCC] = React.useState(false);
                    return (
                      <div
                        className="tdCell icon-btn-group"
                        data-testid="action-column"
                      >
                        {hoverCC ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="com-tooltip">Comment</Tooltip>
                            }
                          >
                            <Button
                              onClick={() => {
                                setErrorMessages([]);
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );

                                setShowComments(true);
                                setLinkTableName('DRUG_AUDIT');
                                setTableName('DRUG_AUDIT');
                              }}
                              tabIndex="0"
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  setCorrLinkId(
                                    cellInfo && cellInfo.data.corrLinkId
                                  );

                                  setShowComments(true);
                                  setLinkTableName('DRUG_AUDIT');
                                  setTableName('DRUG_AUDIT');
                                }
                              }}
                              onMouseOver={() => {
                                setHoverCC(true);
                              }}
                              onMouseOut={() => {
                                setHoverCC(false);
                              }}
                              className={`th-ic comment-ic ${
                                parseInt(
                                  cellInfo.data.ccCommentsExist,
                                  [0, 1]
                                ) === 1
                                  ? 'frr-enabled-comment-btn'
                                  : 'frr-disabled-comment-btn'
                              }`}
                              variant="text"
                            >
                              {parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1 ? (
                                <img alt="comment" src={CommentVisibleIcon} />
                              ) : (
                                <img alt="comment" src={CommentIcon} />
                              )}
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          <Button
                            onClick={() => {
                              setErrorMessages([]);
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setShowComments(true);
                              setLinkTableName('DRUG_AUDIT');
                              setTableName('DRUG_AUDIT');
                            }}
                            tabIndex="0"
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );

                                setShowComments(true);
                                setLinkTableName('DRUG_AUDIT');
                                setTableName('DRUG_AUDIT');
                              }
                            }}
                            onMouseOver={() => {
                              setHoverCC(true);
                            }}
                            onMouseOut={() => {
                              setHoverCC(false);
                            }}
                            className={`th-ic comment-ic ${
                              parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1
                                ? 'frr-enabled-comment-btn'
                                : 'frr-disabled-comment-btn'
                            }`}
                            variant="text"
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                              <img alt="comment" src={CommentVisibleIcon} />
                            ) : (
                              <img alt="comment" src={CommentIcon} />
                            )}
                          </Button>
                        )}
                      </div>
                    );
                  },
                  CheckBoxCellRender: (cellInfo) => {
                    // eslint-disable-next-line no-shadow
                    const invoiceAuditDTabData = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer
                          ?.invoiceAuditDetailObj
                    );
                    const invoiceAuditGridResponse2 = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer
                          .searchInvoiceByCriteriaList
                          ?.invoiceAuditGridResponse2
                    );
                    const drugAuditResObj = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer
                          .searchInvoiceByCriteriaList?.drugAuditResponses
                    );
                    // eslint-disable-next-line no-shadow
                    const addEditReduxInvoiceAuditDetail = (value) =>
                      dispatch(setInvoiceAuditDetailTab(value));
                    return (
                      <>
                        <div className="tbl-checkbox">
                          <FormControlLabel
                            data-testid="checkBox"
                            label="checkbox-invoice"
                            control={
                              <Checkbox
                                color="primary"
                                disabled={!isEnablebyRole}
                              />
                            }
                            className="frr-display-hidden-checkbox-label"
                            onClick={(e) => {
                              if (
                                isEnablebyRole &&
                                e.target.checked !== undefined
                              ) {
                                const checkedVal =
                                  parseInt(cellInfo.value, [0, 1]) === 1
                                    ? 0
                                    : 1;
                                cellInfo.node.setDataValue(
                                  cellInfo.column.colId,
                                  checkedVal
                                );
                                setDisabledSaveCancelBtn(false);
                                setSuccessMessage([]);
                                const newObj = drugAuditResObj || [];
                                const obj = invoiceAuditDTabData || {};
                                addEditReduxInvoiceAuditDetail({
                                  ...obj,
                                  disabledSaveCancelBtn: false,
                                });
                                const rowIndex =
                                  newObj?.length > 0 &&
                                  newObj.findIndex((x) => {
                                    return (
                                      x.id?.toString() ===
                                      cellInfo?.data?.id?.toString()
                                    );
                                  });
                                newObj[rowIndex].addEditRow = true;
                                const Obj = {
                                  invoiceAuditGridResponse2:
                                    invoiceAuditGridResponse2,
                                  drugAuditResponses: newObj,
                                };
                                dispatch(
                                  getSearchInvoiceByCriteriaList(Obj, 'update')
                                );
                                setErrorMessages([]);
                              }
                            }}
                            checked={parseInt(cellInfo.value, [0, 1]) === 1}
                            value={parseInt(cellInfo.value, [0, 1]) === 1}
                            disabled={!isEnablebyRole}
                          />
                        </div>
                      </>
                    );
                  },
                }}
              />
            </div>
          </div>
        )}
      {!fullScreenView1 && !fullScreenView2 && (
        <div className="">
          <div className="">
            {/* {NDCLevelDetailList && NDCLevelDetailList.length > 0 ? ( */}
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner"
            >
              <TableGrid
                data-testid="InvoiceAudit_Drugs"
                rowSelection="single"
                gridDataRendered={onFirstDataRendered}
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '70vh' : viewPortHeight_350_cbi}
                rowData={NDCLevelDetailList}
                columnDefs={TableHeaderForNDCLevelDetail}
                animateRows
                sideBar={false}
                gridCall={onGridReady}
                fileName="InvoiceAudit_Drugs"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                exportWithOtherOption
                handleRedirectURLLink={() => handleGoToAccRecNDCDetail()}
                handleViewDetailsForInvoiceDetail={
                  handleViewDetailsForInvoiceDetail
                }
                onSelect={(e) => {
                  setErrorMessages([]);
                  fetchNDCAuditDescription(e?.data, invoiceAuditDetail);
                  handleClearFilter();
                  setSelectRowData(e.data);
                  setLinkTableName('DRUG_QTR_DETAILS');
                  setTableName('DRUG_QTR_DETAILS');
                  if (!(drugAuditResponses && drugAuditResponses?.length > 0)) {
                    const obj5 = invoiceAuditDTabData || {};
                    addEditReduxInvoiceAuditDetail({
                      ...obj5,
                      disabledSaveCancelBtn: true,
                    });
                    setDisabledSaveCancelBtn(true);
                  }
                }}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const [hoverCCSec, setHoverCCSec] = React.useState(false);

                    const NDCAuditDescriptionList = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer
                          ?.ndcAuditDescriptionList
                    );

                    const fetchState = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer?.searchScreenObj
                          ?.state
                    );
                    return (
                      <div className="tdCell icon-btn-group frr-checkinvoice-icon ">
                        {hoverCCSec ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="com-tooltip">Comment</Tooltip>
                            }
                          >
                            <Button
                              type="button"
                              onClick={() => {
                                setErrorMessages([]);
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );
                                setLinkTableName('DRUG_QTR_DETAILS');
                                setTableName('');
                                setShowComments(true);
                              }}
                              tabIndex="0"
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  setCorrLinkId(
                                    cellInfo && cellInfo.data.corrLinkId
                                  );

                                  setShowComments(true);
                                  setLinkTableName('DRUG_QTR_DETAILS');
                                  setTableName('');
                                }
                              }}
                              onMouseOver={() => {
                                setHoverCCSec(true);
                              }}
                              onMouseOut={() => {
                                setHoverCCSec(false);
                              }}
                              className="th-ic comment-ic frr-enabled-comment-btn"
                              variant="text"
                            >
                              {parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1 ? (
                                <img alt="comment" src={CommentVisibleIcon} />
                              ) : (
                                <img alt="comment" src={CommentIcon} />
                              )}
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          <Button
                            type="button"
                            onClick={() => {
                              setErrorMessages([]);
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('DRUG_QTR_DETAILS');
                              setTableName('');
                              setShowComments(true);
                            }}
                            tabIndex="0"
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );

                                setShowComments(true);
                                setLinkTableName('DRUG_QTR_DETAILS');
                                setTableName('');
                              }
                            }}
                            onMouseOver={() => {
                              setHoverCCSec(true);
                            }}
                            onMouseOut={() => {
                              setHoverCCSec(false);
                            }}
                            className="th-ic comment-ic frr-enabled-comment-btn"
                            variant="text"
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                              <img alt="comment" src={CommentVisibleIcon} />
                            ) : (
                              <img alt="comment" src={CommentIcon} />
                            )}
                          </Button>
                        )}
                        <Dropdown className="icon-dropdown-container float-right">
                          <Dropdown.Toggle
                            className="icon-dropdown"
                            aria-label="export"
                          >
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="action-tooltip">Action</Tooltip>
                              }
                            >
                              <SVGComponent iconName="Icon-export1" />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="export_dropdown h-auto">
                            <Dropdown.Item
                              disabled={
                                !(
                                  NDCAuditDescriptionList &&
                                  NDCAuditDescriptionList.length > 0
                                ) || !isEnablebyRole
                              }
                              onClick={() => {
                                setErrorMessages([]);
                                setClearAuditPopup(true);
                                handleClearFilter();
                                setClearAuditData(cellInfo.data);
                                if (
                                  !(
                                    NDCAuditDescriptionList?.filter((x) => {
                                      return (
                                        x.drugSeqNum ===
                                        cellInfo?.data?.drugSeqNum
                                      );
                                    }).length > 0
                                  )
                                ) {
                                  dispatch(
                                    getNDCAuditDescription({
                                      drugSeqNum: cellInfo.data?.drugSeqNum,
                                      auditType:
                                        fetchState &&
                                        fetchState.auditTypeCd === 'Selected'
                                          ? fetchState.selectedAuditType
                                          : fetchState.auditTypeCd,
                                      rebateProgramCode:
                                        invoiceAuditDetail.rebateProgramCd,
                                      quarter: invoiceAuditDetail.quarter,
                                      clearedIndex: fetchState?.clearedIndex
                                        ? 1
                                        : 0,
                                      asCode: fetchState.selectBy,
                                    })
                                  );
                                }
                              }}
                            >
                              {' '}
                              Clear Audits for NDC
                            </Dropdown.Item>
                            <Dropdown.Item
                              role="button"
                              onClick={() => {
                                setErrorMessages([]);
                                handleViewDetailsForClaims(cellInfo.data);
                              }}
                            >
                              {' '}
                              Go To Claims
                            </Dropdown.Item>
                            <Dropdown.Item
                              role="button"
                              onClick={() => {
                                setErrorMessages([]);
                                dispatch(dispatchAllNDCs(null));
                                dispatch(handleErrorMessagesClear([]));
                                dispatch(
                                  dispatchAllNDCs({
                                    message: 'SUCESS',
                                    data: cellInfo.data,
                                  })
                                );
                                handleViewDetailsForUnitConversion(
                                  cellInfo.data
                                );
                              }}
                            >
                              {' '}
                              Go To Maintain Unit Conversion
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  NDCCellRender: (cellInfo) => {
                    const [hoverUnder, setHoverUnder] = React.useState(false);

                    return (
                      <div
                        className={
                          hoverUnder ? 'frr-text-decoration-underline' : ''
                        }
                      >
                        <Link
                          to="#"
                          role="button"
                          tabIndex={0}
                          onClick={() => {
                            setErrorMessages([]);
                            handleViewDetailsForNDC(cellInfo?.data);
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === 'Enter' ||
                              e.key === ' ' ||
                              e.keyCode === 'Spacebar'
                            ) {
                              // console.log('e', e.key);
                              e.preventDefault();
                              setErrorMessages([]);
                              handleViewDetailsForNDC(cellInfo?.data);
                            }
                          }}
                          onMouseOver={() => {
                            setHoverUnder(true);
                          }}
                          onMouseOut={() => {
                            setHoverUnder(false);
                          }}
                        >
                          {cellInfo && cellInfo?.data?.ndc}
                        </Link>
                      </div>
                    );
                  },
                }}
              />
            </div>
            {/* ) : null} */}
          </div>
        </div>
      )}
      {!fullScreenView && !fullScreenView2 && stateCCAuditTable && (
        <div className="">
          {NDCLevelDetailList && NDCLevelDetailList?.length > 0 ? (
            <div className="">
              <TableGrid
                ref={gridRef}
                data-testid="InvoiceAuditTypeCodes"
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView1}
                handleFullScreenViewClick={handleFullScreenView1}
                gridHeight={fullScreenView1 ? '70vh' : viewPortHeight_350_cbi}
                rowData={
                  Array.isArray(NDCAuditDescriptionList)
                    ? NDCAuditDescriptionList
                    : []
                }
                columnDefs={TableHeaderForNDCAuditDescription}
                exportFile
                animateRows
                isScrollOn
                sideBar={false}
                fileName="InvoiceAuditTypeCodes"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                gridCall={onGridReadyForDrugAuditDes}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                onSelect={(e) => {
                  setErrorMessages([]);
                  setSelectRowData(e.data);
                  setLinkTableName('DRUG_AUDIT');
                  setTableName('DRUG_AUDIT_DES');
                }}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const [hoverCCTh, setHoverCCTh] = React.useState(false);
                    return (
                      <div
                        className="tdCell icon-btn-group"
                        data-testid="action-column"
                      >
                        {hoverCCTh ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="com-tooltip">Comment</Tooltip>
                            }
                          >
                            <Button
                              onClick={() => {
                                setErrorMessages([]);
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );
                                setLinkTableName('DRUG_AUDIT');
                                setTableName('DRUG_AUDIT_DES');
                                setShowComments(true);
                              }}
                              tabIndex="0"
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  setCorrLinkId(
                                    cellInfo && cellInfo.data.corrLinkId
                                  );
                                  setLinkTableName('DRUG_AUDIT');
                                  setTableName('DRUG_AUDIT_DES');
                                  setShowComments(true);
                                }
                              }}
                              onMouseOver={() => {
                                setHoverCCTh(true);
                              }}
                              onMouseOut={() => {
                                setHoverCCTh(false);
                              }}
                              className={`th-ic comment-ic ${
                                parseInt(
                                  cellInfo.data.ccCommentsExist,
                                  [0, 1]
                                ) === 1
                                  ? 'frr-enabled-comment-btn'
                                  : 'frr-disabled-comment-btn'
                              }`}
                              variant="text"
                            >
                              {parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1 ? (
                                <img alt="comment" src={CommentVisibleIcon} />
                              ) : (
                                <img alt="comment" src={CommentIcon} />
                              )}
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                          <Button
                            onClick={() => {
                              setErrorMessages([]);
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('DRUG_AUDIT');
                              setTableName('DRUG_AUDIT_DES');
                              setShowComments(true);
                            }}
                            tabIndex="0"
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setCorrLinkId(
                                  cellInfo && cellInfo.data.corrLinkId
                                );
                                setLinkTableName('DRUG_AUDIT');
                                setTableName('DRUG_AUDIT_DES');
                                setShowComments(true);
                              }
                            }}
                            onMouseOver={() => {
                              setHoverCCTh(true);
                            }}
                            onMouseOut={() => {
                              setHoverCCTh(false);
                            }}
                            className={`th-ic comment-ic ${
                              parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1
                                ? 'frr-enabled-comment-btn'
                                : 'frr-disabled-comment-btn'
                            }`}
                            variant="text"
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                              <img alt="comment" src={CommentVisibleIcon} />
                            ) : (
                              <img alt="comment" src={CommentIcon} />
                            )}
                          </Button>
                        )}
                      </div>
                    );
                  },
                  CheckBoxCellRender: (cellInfo) => {
                    // eslint-disable-next-line no-shadow
                    const invoiceAuditDTabData = useSelector(
                      (state) =>
                        state.sharedState.InvoiceAuditsReducer
                          ?.invoiceAuditDetailObj
                    );
                    // eslint-disable-next-line no-shadow
                    const addEditReduxInvoiceAuditDetail = (value) =>
                      dispatch(setInvoiceAuditDetailTab(value));
                    return (
                      <>
                        <div
                          className="tbl-checkbox frr-checkbox-no-label"
                          data-testid="checkbox-com"
                        >
                          <FormControlLabel
                            data-testid="checkBox"
                            label="checkbox-invoice"
                            className="frr-display-hidden-checkbox-label"
                            control={
                              <Checkbox
                                color="primary"
                                disable={!isEnablebyRole}
                                checked={
                                  parseInt(
                                    cellInfo?.data.auditClearedInd,
                                    [0, 1]
                                  ) === 1
                                }
                                value={
                                  parseInt(
                                    cellInfo?.data.auditClearedInd,
                                    [0, 1]
                                  ) === 1
                                }
                              />
                            }
                            onClick={(e) => {
                              if (
                                isEnablebyRole &&
                                e.target.checked !== undefined
                              ) {
                                setErrorMessages([]);
                                const checkedVal =
                                  parseInt(
                                    cellInfo?.data?.auditClearedInd,
                                    [0, 1]
                                  ) === 1
                                    ? 0
                                    : 1;
                                cellInfo.node.setDataValue(
                                  cellInfo.column.colId,
                                  checkedVal
                                );
                                setDisabledSaveCancelBtn(false);
                                setSelectedData([cellInfo?.data]);
                                setSuccessMessage([]);
                                const obj = invoiceAuditDTabData || {};
                                addEditReduxInvoiceAuditDetail({
                                  ...obj,
                                  disabledSaveCancelBtn: false,
                                });
                              }
                            }}
                            checked={
                              parseInt(
                                cellInfo?.data.auditClearedInd,
                                [0, 1]
                              ) === 1
                            }
                            value={
                              parseInt(
                                cellInfo?.data.auditClearedInd,
                                [0, 1]
                              ) === 1
                            }
                            disabled={!isEnablebyRole}
                          />
                        </div>
                      </>
                    );
                  },
                }}
              />
            </div>
          ) : null}
        </div>
      )}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={linkTableName}
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};
export default InvoiceAuditViewDetails;
